import { resolveMediaUrl } from "../../lib/api";

export const ServiceVideoSection = ({ videoUrl }) => {
  if (!videoUrl) return null;
  return (
    <div data-testid="service-video-section">
      <video data-testid="service-video-player" controls className="w-full aspect-video bg-black border border-white/10">
        <source src={resolveMediaUrl(videoUrl)} />
      </video>
    </div>
  );
};
